<template>
  <v-card
    class="mx-auto my-4"
    max-width="500"
  >
    <v-card-title>
      You are now logged in!
    </v-card-title>
    <v-card-subtitle>
      Account features coming soon...
    </v-card-subtitle>
  </v-card>
</template>
<script>
export default {
  name: 'Dashboard'
}
</script>
